module.exports = __webpack_public_path__ + "img/SOWEE_80X30.04e0c5a0.png";